import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import styles from './position-filter-card-list.module.scss';

const FilterCardItem = ({ data }) => {
  return (
    <div className={styles.filterCardItem}>
      <h3 className={`${styles.cardTitle} word-break`}>{data[0]?.key}</h3>
      <div className={styles.cardContent}>
        {!isEmpty(data) &&
          data.map((item, index) => (
            <div key={index} className={styles.cardContentItem}>
              <p className={styles.itemName}>{item?.name}</p>
              <p className={styles.itemDetail}>
                {JSON.stringify(item?.value || '').includes('(') ? (
                  <>
                    <span className={styles.boldText}>{`${item?.value.split(/[()]/)[0]}`}</span>
                    <span>{`(${item?.value.split(/[()]/)[1]})`}</span>
                  </>
                ) : (
                  <span className={styles.boldText}>{`${item?.value}`}</span>
                )}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};

const PositionFilterCardList = (props) => {
  const { data, customStyles } = props;

  const convertData = (key, value, filterName) => {
    let tempVal;
    switch (key) {
      case 'male':
        tempVal = {
          key: filterName,
          name: 'Male',
          value,
        };
        break;
      case 'female':
        tempVal = {
          key: filterName,
          name: 'Female',
          value,
        };
        break;
      case 'national':
        tempVal = {
          key: filterName,
          name: 'Malaysian',
          value,
        };
        break;
      case 'non_national':
        tempVal = {
          key: filterName,
          name: 'Other Nationalities',
          value,
        };
        break;
      case 'under_35':
        tempVal = {
          key: filterName,
          name: '35 & Below',
          value,
        };
        break;
      case 'above_36':
        tempVal = {
          key: filterName,
          name: '36 & Above',
          value,
        };
        break;
      default:
        break;
    }
    return tempVal;
  };

  const cloneData = useMemo(() => {
    return !isEmpty(data)
      ? data
          .filter((d) => d?.value)
          .map((item) => {
            if (Object.keys(item.value).length > 0) {
              return Object.keys(item.value).map((key) => {
                return convertData(key, item.value[key], item?.key);
              });
            }
          })
      : [];
  }, [data]);

  return (
    <div className={styles.filterCardWrap} style={customStyles ? customStyles : null}>
      {!isEmpty(cloneData) && cloneData.map((item, index) => <FilterCardItem key={index} data={item}></FilterCardItem>)}
    </div>
  );
};

export default PositionFilterCardList;
